<template>
  <el-row class="warp">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }"><b>首页</b></el-breadcrumb-item>
        <el-breadcrumb-item>保障人员</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>

    <el-col :span="24" class="warp-main" v-loading="loading" element-loading-text="拼命加载中">
      <!--工具条-->
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
        <el-form :inline="true" :model="filters">
          <el-form-item>
            <el-input v-model="filters.name" placeholder="姓名" style="min-width: 240px;"
                      @keyup.enter.native="handleSearch"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="showAddDialog">添加</el-button>
          </el-form-item>
        </el-form>
      </el-col>

      <!--列表-->
      <el-table :data="users" highlight-current-row border >
        <el-table-column type="index" width="60" fixed="left"></el-table-column>
        <el-table-column prop="name" label="姓名" width="120" fixed="left" sortable></el-table-column>
        <el-table-column prop="mobile" label="手机号" width="120" sortable></el-table-column>
        <el-table-column prop="typeName" label="类型" sortable></el-table-column>
        <el-table-column prop="sexName" label="性别" width="100" sortable></el-table-column>
        <el-table-column prop="certTypeName" label="证件类型" width="120" sortable></el-table-column>
        <el-table-column prop="certNo" label="证件号码" width="180" sortable></el-table-column>
        <el-table-column prop="email" label="邮箱" min-width="160" sortable></el-table-column>
        <el-table-column prop="birth" label="出生日期" min-width="160" sortable></el-table-column>
        <el-table-column prop="address" label="户口地" min-width="180" sortable></el-table-column>
        <el-table-column prop="liveAddress" label="居住地" min-width="180" sortable></el-table-column>
        <el-table-column prop="statusName" label="状态"  sortable></el-table-column>
        <el-table-column label="操作" fixed="right" width="220">
          <template slot-scope="scope">
            <el-button size="mini" type="info" @click="showEditDialog(scope.$index,scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="removeUser(scope.$index,scope.row)">删除</el-button>
            <el-button size="mini" type="primary" @click="bingProject(scope.$index,scope.row)">项目</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100]"
          :page-size="10" background layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:right;">
        </el-pagination>
      </el-col>

      <!-- 添加、修改界面 -->
      <el-dialog :title="form.title" :visible.sync="form.visible" :close-on-click-modal="false" >
        <el-form :model="form.data" label-width="80px" :rules="form.rules" ref="formref">
          <table style="width: 100%;">
            <tr>
              <td>
                <el-form-item label="姓名" prop="name" class="clear-margin-bottom">
                  <el-input v-model="form.data.name" auto-complete="off"></el-input>
                </el-form-item>
              </td>
              <td>
                <el-form-item label="所属机构" class="clear-margin-bottom">
                  <TreeSelect ref="addtreeSelect" 
                    :props="form.props"
                    :options="form.orgs"
                    :value="form.valueId"
                    :clearable="form.isClearable"
                    :accordion="form.isAccordion"
                    @getValue="getValue($event)"
                   >
                  </TreeSelect>  
                </el-form-item>
              </td>
            </tr>
             <tr>
              <td>
                <el-form-item label="人员类型" prop="type">
                  <el-select v-model="form.data.type" clearable placeholder="请选择">
                    <el-option v-for="item in form.dicSafeUserType" :key="item.value" :label="item.name" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </td>
              <td>
                <el-form-item label="用户状态" prop="status">
                  <el-select v-model="form.data.status" clearable placeholder="请选择">
                    <el-option v-for="item in form.dictStatus" :key="item.value" :label="item.name" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td>
                <el-form-item label="性别" prop="sex" class="clear-margin-bottom">
                  <el-select v-model="form.data.sex" clearable placeholder="请选择">
                    <el-option v-for="item in form.dictSex" :key="item.value" :label="item.name" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </td>
              <td>
                <el-form-item label="出生日期" prop="birth" class="clear-margin-bottom">
                  <el-date-picker type="date" placeholder="出生日期" v-model="form.data.birth"></el-date-picker>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td>
                <el-form-item label="证件类型" prop="certType" class="clear-margin-bottom">
                  <el-select v-model="form.data.certType" clearable placeholder="请选择"  style="width:200;">
                    <el-option v-for="item in form.dictCertType" :key="item.value" :label="item.name" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </td>
              <td>
                <el-form-item label="证件号码" prop="certNo" class="clear-margin-bottom">
                  <el-input v-model="form.data.certNo" auto-complete="off"></el-input>
                </el-form-item>
              </td>
            </tr>
            
            <tr>
              <td>
                <el-form-item label="手机号" prop="mobile" class="clear-margin-bottom">
                  <el-input v-model="form.data.mobile" auto-complete="off"></el-input>
                </el-form-item>
              </td>
              <td>
                <el-form-item label="邮箱" prop="email" class="clear-margin-bottom">
                  <el-input type="email" v-model="form.data.email" auto-complete="off"></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td>
                 <el-form-item label="户口地址" prop="address" class="clear-margin-bottom">
                  <el-input v-model="form.data.address" auto-complete="off"></el-input>
                </el-form-item>
              </td>
              <td>
                 <el-form-item label="居住地址" prop="liveAddress" class="clear-margin-bottom">
                  <el-input v-model="form.data.liveAddress" auto-complete="off"></el-input>
                </el-form-item>
              </td>
            </tr>
          </table>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="form.visible=false">取消</el-button>
          <el-button type="primary" @click.native="form.submit" :loading="loading">提交</el-button>
        </div>
      </el-dialog>

      <!-- 项目 -->
      <el-dialog title="项目绑定" :visible.sync="project.visible" :close-on-click-modal="false" width="80%" @opened="myopened" >
          <el-form :inline="true" :model="project.filter">
            <el-form-item>
              <el-input v-model="project.filter.projectName" placeholder="项目名称" style="min-width: 240px;"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="projectSearch">查询</el-button>
            </el-form-item>
          </el-form>
          <template>
            <el-table
              ref="multipleTable"
              :data="project.data"
              tooltip-effect="dark"
              style="width: 100%"
              @selection-change="prjectHandleSelectionChange">
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column  prop="name" label="项目名" width="160"></el-table-column>
              <el-table-column  prop="custName" label="企业" width="320"></el-table-column>
              <el-table-column prop="provinceName" label="省" width="100"></el-table-column>
              <el-table-column prop="cityName" label="市" width="100"></el-table-column>
              <el-table-column prop="districtName" label="区/县" width="100" ></el-table-column>
              <el-table-column prop="addressDetail" label="地址" ></el-table-column>
            </el-table> 
            <br/> 
            <el-pagination @size-change="projectHandleSizeChange" @current-change="projectHandleCurrentChange" :page-sizes="[10, 20, 50, 100]"  :current-page.sync="project.current"
              :page-size="10" background layout="total, sizes, prev, pager, next, jumper" :total="project.total" style="float:right;">
            </el-pagination>     
            <br/>
          </template>
      </el-dialog>
    </el-col>
  </el-row>
</template>

<script>
  import API from "../../api/safeuser/index";
  import ORG_API from "../../api/api_org";
  import TreeSelect from '@/components/selectTree/treeSelect.vue';

  export default {
    components: { TreeSelect },
    data() {
      return {
        loading:false,
        users: [],
        total: 0,
        page: 1,
        limit: 10,
        //条件
        filters:{
          name:"",
        },
        //编辑窗体  
        form:{
          loading:false, //加载动画
          title:'', //编辑窗体名称
          visible:false, //窗体是否显示
          rules:{//验证逻辑
            name: [
              {required: true, message: "请输入姓名", trigger:['blur','change']},
              { min: 2,max:20,message: '长度2-20个字符', trigger: ['blur','change']}
            ],
            type:[ {required: true, message: "请选择人员类型", trigger:['blur','change']},],
            status:[ {required: true, message: "请选择用户状态", trigger:['blur','change']},],
            sex:[ {required: true, message: "请选择性别", trigger:['blur','change']},],
            birth:[ {required: true, message: "请输入出生年月 ", trigger:['blur','change']},],
            certType:[ {required: true, message: "请选择证件类型", trigger:['blur','change']},],
            certNo:[ {required: true, message: "请输入证件号码", trigger:['blur','change']},],
            mobile:[ {required: true, message: "请输入手机号码", trigger:['blur','change']},],
            email:[ {required: true, message: "请输入邮箱地址", trigger:['blur','change']},],
            address:[ {required: true, message: "请输入户籍地址", trigger:['blur','change']},],
            liveAddress:[ {required: true, message: "请输入现居住地址", trigger:['blur','change']},]
          },   
          data:{},  //内容
          isClearable:true,      // 可清空（可选）
          isAccordion:true,      // 可收起（可选）
          valueId:'',            // 初始ID（可选）
          props:{                // 配置项（必选）
            value: 'id',
            label: 'name',
            children: 'children',
          },
          orgs:[],
          dictSex: [],
          dictCertType: [],
          dictStatus: [],
          dicSafeUserType:[],
          //定义form的提交按钮

          submit:function(){},
        }, 
        //项目
        project:{
          loadData:false,
          total: 0,
          page: 1,
          current:1,
          limit: 10,
          visible:false,//绑定项目窗体显示
          filter:{ //查询条件
            projectName:"",
          },
          data:[],//表格数据
          multipleSelection: [],//选中的项目
          handleSelectionChange:function(val){
          },
         
        }
      };
    },
    watch:{
      "project.page"(val){
        let that =this;
        that.project.refreshState=true;
      }
    },
    methods:{
      //文本框不能输入中文
      check_zh(){
        let that = this;
        that.addForm.userName = that.addForm.userName.replace(/[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/g, '');
      },
      // 下拉列表取值事件
      getValue(value){
        let that =this;
        that.form.valueId = value;
        that.form.data.orgId=value; //选择某个机构，赋值id
      },
      //价格控件值
      initData(back){
            let that =this;
            API.init("")
              .then(
                function (result) {
                  that.loading = false;
                  if (result && result.code == 200) {
                    console.log(result.data);
                    that.form.orgs=result.data.org;
                    that.form.dictSex=result.data.dictSex;
                    that.form.dictCertType= result.data.dictCertType;
                    that.form.dictStatus = result.data.dictStatus;
                    that.form.dicSafeUserType= result.data.dicSafeUserType;
                    if(back){
                      back();
                    }
                  }
                },
                function (err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function (error) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
      },
      //获取用用户列表
      search: function () {
        let that = this;
        let params = {
          page: that.page,
          limit: that.limit,
          name: that.filters.name
        };

        that.loading = true;
        API.getList(params)
          .then(
            function (result) {
              that.loading = false;
              if (result && result.code == 200) {
                that.total = result.data.total;
                that.users = result.data.rows;
              }
            },
            function (err) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function (error) {
            that.loading = false;
            console.log(error);
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
      },
      handleSizeChange(val) {
        this.limit = val;
        this.search();
      },
      handleCurrentChange(val) {
        this.page = val;
        this.search();
      },
      handleSearch() {
        this.initData();
        this.total = 0;
        this.page = 1;
        this.search();
      },
      //添加
      showAddDialog(){
        let that =this;
        that.form.title="新增人员 ";
        that.form.data={};
        //第一次打开，还没有渲染组件，所以需要判断下是否已经初始化
        if(that.$refs.addtreeSelect){
          that.$refs.addtreeSelect.clearHandle();
        }
        that.form.visible=true;
        that.form.valueId=null;

        that.form.submit=function(){
          that.$refs.formref.validate(valid => {
            if(valid){
              API.insert(that.form.data)
                .then(
                    function (result) {
                      that.loading = false;
                      if (result && result.code == 200) {
                        that.$message.success({
                          showClose: true,
                          message: "新增成功",
                          duration: 2000
                        });
                        that.form.visible = false;
                        that.search();
                      }
                      else{
                          that.$message.error({
                          showClose: true,
                          message: result.msg,
                          duration: 2000
                        });
                      }
                    },
                    function (err) {
                    that.loading = false;
                    that.$message.error({
                        showClose: true,
                        message: err.toString(),
                        duration: 2000
                    });
                    }
                )
                .catch(function (error) {
                    that.loading = false;
                    console.log(error);
                    that.$message.error({
                    showClose: true,
                    message: "请求出现异常",
                    duration: 2000
                    });
                });
            }
          })
          
        }
      },
      //编辑
      showEditDialog(index,row){
        let that =this;
        
        that.form.title="编辑人员 ";
        that.form.data={};
        //第一次打开，还没有渲染组件，所以需要判断下是否已经初始化
        if(that.$refs.addtreeSelect){
          that.$refs.addtreeSelect.clearHandle();
        }
       
        that.form.visible=true;
        that.loading = true;
        API.detail({userId:row.id})
                .then(
                    function (result) {
                      if (result && result.code == 200) {
                        that.loading=false;
                        console.log(result.data);
                        //赋值
                        that.form.valueId=null;
                        that.form.valueId = result.data.orgId=="0"?null:result.data.orgId;
                        that.form.data=result.data;
                      }
                      else{
                          that.$message.error({
                          showClose: true,
                          message: result.msg,
                          duration: 2000
                        });
                      }
                    },
                    function (err) {
                    that.loading = false;
                    that.$message.error({
                        showClose: true,
                        message: err.toString(),
                        duration: 2000
                    });
                    }
                )
                .catch(function (error) {
                    that.loading = false;
                    that.$message.error({
                    showClose: true,
                    message: "请求出现异常",
                    duration: 2000
                    });
                });
      
        //提交
        that.form.submit=function(){
           that.$confirm('如果修改【所属机构】需要重新绑定项目，您还继续修改吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              that.$refs.formref.validate(valid => {
                if(valid){
                  API.update(that.form.data)
                    .then(
                        function (result) {
                          that.loading = false;
                          if (result && result.code == 200) {
                            that.$message.success({
                              showClose: true,
                              message: "修改成功",
                              duration: 2000
                            });
                            that.form.visible = false;
                            that.search();
                          }
                          else{
                              that.$message.error({
                              showClose: true,
                              message: result.msg,
                              duration: 2000
                            });
                          }
                        },
                        function (err) {
                        that.loading = false;
                        that.$message.error({
                            showClose: true,
                            message: err.toString(),
                            duration: 2000
                        });
                        }
                    )
                    .catch(function (error) {
                        that.loading = false;
                        console.log(error);
                        that.$message.error({
                        showClose: true,
                        message: "请求出现异常",
                        duration: 2000
                        });
                    });
                }
              })
            }).catch(() => {
              
            });
           
          
        }
      },
      //删除
      removeUser(index,row){
        let that = this;
        this.$confirm("确认删除该记录吗?", "提示", {type: "warning"})
          .then(() => {
            that.loading = true;
            API.delete(row.id)
              .then(
                function (result) {
                  that.loading = false;
                  if (result && result.code === 200) {
                    that.$message.success({
                      showClose: true,
                      message: "删除成功",
                      duration: 1500
                    });
                    that.search();
                  }else{
                    that.$message.error({
                      showClose: true,
                      message: result.msg,
                      duration: 1500
                    });
                  }
                },
                function (err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function (error) {
                that.loading = false;
                console.log(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {
          });
      },
      myopened(){
        let that =this;
        //便利结果，如果选择，则勾选。初始化不调用勾选事件
        that.project.loadData=true;
        that.project.data.forEach(row => {
          if(row.safeUserId==that.project.filter.safeUserId)
          {
            that.$refs.multipleTable.toggleRowSelection(row,true);
            that.project.multipleSelection.push(row);
          }
        });
        that.project.loadData=false;
      },
      //定义查询方法
      projectSearch(){
        let that =this;
        that.project.refreshState=true;
          let params = {
            page: that.project.page,
            limit: that.project.limit,
            projectName: that.project.filter.projectName,
            safeUserId:that.project.filter.safeUserId
          };
          //加载项目数据
          API.getPojects(params)
            .then(
              function (result) {
                that.loading = false;
                if (result && result.code == 200) {
                  that.project.total = result.data.total;
                  that.project.data = result.data.rows;
                  that.project.multipleSelection=[];
                }
              },
              function (err) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function (error) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
      },
      projectHandleSizeChange:function(val){
        this.project.limit = val;
        this.projectSearch();
        
      },
      projectHandleCurrentChange:function(val){
        this.project.page = val;
        this.projectSearch();
      },
      //项目
      bingProject(index,row){
        let that=this;
        that.project.page=1;
        that.project.current=1;
        that.project.visible=true;
        that.project.filter.safeUserId=row.id;
        //执行查询
        that.projectSearch();
      },
      prjectHandleSelectionChange(val){
        let that=this;
          if(that.project.loadData) return;
          if(val.length>that.project.multipleSelection.length)
          {
            //求差集
            var temp = val.filter(function(v){ return that.project.multipleSelection.indexOf(v) == -1 });
            var projectIds=[];
            temp.forEach(t=>{
              projectIds.push(t.id);
            });
            //console.log(projectIds);
            //勾选提交
            let params={
              projectIds:projectIds,
              safeUserId:that.project.filter.safeUserId
            }
            API.bindProject(params)
              .then(
                function (result) {
                  that.loading = false;
                  if (result && result.code == 200) {
                   that.project.multipleSelection=val;
                  }else{
                     that.$refs.multipleTable.toggleRowSelection(temp[0]);
                  }
                },
                function (err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                  that.$refs.multipleTable.toggleRowSelection(temp[0]);
                }
              )
              .catch(function (error) {
                that.loading = false;
                console.log(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          }
          //取消勾选
          if(val.length<that.project.multipleSelection.length)
          {
            //求差集
            var temp = that.project.multipleSelection.filter(function(v){ return val.indexOf(v) == -1 });
            var projectIds=[];
            temp.forEach(t=>{
              projectIds.push(t.id);
            });
            //取消勾选提交
            let params={
              projectIds:projectIds,
              safeUserId:that.project.filter.safeUserId
            }
            API.unbindProject(params)
              .then(
                function (result) {
                  that.loading = false;
                  if (result && result.code == 200) {
                    that.project.multipleSelection=val;
                  }else{
                     that.$refs.multipleTable.toggleRowSelection(temp[0]);
                  }
                },
                function (err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                  that.$refs.multipleTable.toggleRowSelection(temp[0]);
                }
              )
              .catch(function (error) {
                that.loading = false;
                console.log(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          }
          
        }


    },
    mounted() {
      this.handleSearch();
    },
    updated(){
      let that =this;
      //判断是project的table更新了执行
      if(that.project.refreshState){
        //便利结果，如果选择，则勾选。初始化不调用勾选事件
        that.project.loadData=true;
        that.project.data.forEach(row => {
          console.log(row);
          if(row.safeUserId==that.project.filter.safeUserId)
          {
            that.$refs.multipleTable.toggleRowSelection(row,true);
            that.project.multipleSelection.push(row);
          }
        });
        that.project.refreshState=false;
        that.project.loadData=false;
      }
    }
  };
</script>



// WEBPACK FOOTER //
// list.vue?536540af